import React, { Component } from "react";
import maskText from "../helpers/maskText";
export default class OrderDetailAdress extends Component {
  render() {
    const address = this.props.address || {};

    return (
      <table
        className={"table table-bordered table-hover"}
        style={{ marginTop: 20 }}
      >
        <thead>
          <tr>
            <td colspan={2}>Sipariş Teslimat Adresi</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Adres Adı:</strong>
            </td>
            <td>
              {this.props.customer
                ? address.address_name || ''
                : maskText(address.address_name || '', 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Adı Soyadı:</strong>
            </td>
            <td>
              {this.props.customer
                ? address.full_name || ''
                : maskText(address.full_name || '', 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>İl:</strong>
            </td>
            <td>
              {this.props.customer
                ? address.city || ''
                : maskText(address.city || '', 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>İlçe:</strong>
            </td>
            <td>
              {this.props.customer
                ? address.town || ''
                : maskText(address.town || '', 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Posta Kodu:</strong>
            </td>
            <td>
              {this.props.customer
                ? address.postal_code || ''
                : maskText(address.postal_code || '', 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Telefon:</strong>
            </td>
            <td>
              {this.props.customer
                ? address.phone || ''
                : maskText(address.phone || '', 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Adres:</strong>
            </td>
            <td>
              {this.props.customer
                ? address.address || ''
                : maskText(address.address || '', 2)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrderDetailAdress.js